import type { JSX } from 'react';
import { Plus } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CompanyUserFormFields } from './CompanyUserFormFields';
import { EmailField, PasswordField, FormFooter } from './CreateCompanyUserDialog.fields';
import { useCreateCompanyUserForm } from './CreateCompanyUserDialog.hooks';
import type { CompanyRoleName } from '../types/company-admin.types';

export function CreateCompanyUserDialog(): JSX.Element {
  const form = useCreateCompanyUserForm();

  return (
    <Dialog open={form.open} onOpenChange={form.setOpen}>
      <DialogTrigger asChild>
        <Button>
          <Plus className="h-4 w-4 mr-2" />
          Add User
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Create User</DialogTitle>
        </DialogHeader>
        <form onSubmit={form.onSubmit} className="space-y-4">
          <EmailField register={form.register} error={form.errors.email} />
          <CompanyUserFormFields
            firstNameProps={form.register('firstName')}
            lastNameProps={form.register('lastName')}
            phoneProps={form.register('phone')}
            errors={form.errors}
            selectedRole={form.watch('initialRole') ?? 'AGENT'}
            onRoleChange={(v) => form.setValue('initialRole', v as CompanyRoleName)}
          />
          <PasswordField register={form.register} error={form.errors.password} />
          {form.errors.initialRole && (
            <p className="text-sm text-destructive">{form.errors.initialRole.message}</p>
          )}
          <FormFooter isPending={form.isPending} onCancel={() => form.setOpen(false)} />
        </form>
      </DialogContent>
    </Dialog>
  );
}
